import ResetPasswordConfirm from './ResetPasswordConfirm'

export default ResetPasswordConfirm
